module.exports = __webpack_public_path__ + "media/images/charity-2-aa6a367a96250d7c6f11ca6d318de5a0.jpg";